:host { /* NOSONAR */
    a {
        color: $pl-link-color-primary;
        text-decoration: none;

        &:hover {
            text-decoration: underline;
        }
    }

    h4 {
        margin: 0 0 $polaris-space-1;
        font-weight: $polaris-font-weight-normal;
        font-size: $polaris-font-size-3;
        line-height: $polaris-line-height-3;
    }

    p {
        margin: 0;
    }

    .ti-e2e-support-forums-container {
        margin: 0 0 $polaris-space-6 0;
        padding: 0;
        list-style-type: none;
        column-count: 2;

        @include mix-for-sizes-down(phone) {
            margin: 0;
        }

        &.ti-e2e-support-forums-single-column {
            column-count: 1;
            width: 50%;

            @include mix-for-sizes-down(tablet) {
                width: 100%;
            }
        }

        @include mix-for-sizes-down(tablet) {
            column-count: 1;

            .ti-e2e-support-forums-row-item {
                margin-right: 0;
            }
        }
    }

    .ti-e2e-support-forums-row-item {
        margin: 0 $polaris-space-6 $polaris-space-6 0;
        word-break: break-word;
        line-height: $polaris-line-height-2;
        page-break-inside: avoid; // This prevents list item from spilling over to next column
    }

    .ti-e2e-support-forums-loader-container {
        display: flex;
        justify-content: center;
        margin: $polaris-space-4;
    }

}
